import { createSlice } from '@reduxjs/toolkit';

export interface TableState<T> {
  content: T[];
  page: number;
  size: number;
  total: number;
  query?: string;
  fetching: boolean;
  shouldRefresh: boolean;
}

export const initialTableState = <T>(size?: number): TableState<T> => {
  return {
    content: [],
    page: 0,
    size: size || 20,
    total: 0,
    fetching: false,
    shouldRefresh: false,
  };
};

export interface TablesState {
  [key: string]: TableState<any>;
}

export const initialState: TablesState = {};

const tablesSlice = createSlice({
  name: 'tables',
  initialState,
  reducers: {
    fetchContentSuccess: (state, action) => {
      const table = state[action.payload.name] || initialTableState(action.payload.pageSize);
      const { content, total, number } = action.payload.content;
      table.content = content;
      table.total = total;
      table.page = number;
      state[action.payload.name] = table;
    },
    setQuery: (state, action) => {
      const table = state[action.payload.name] || initialTableState();
      table.query = action.payload.query;
      table.page = 0;
      state[action.payload.name] = table;
    },
    setPage: (state, action) => {
      const table = state[action.payload.name] || initialTableState();
      table.page = action.payload.page;
      state[action.payload.name] = table;
    },
    setRefresh: (state, action) => {
      const table = state[action.payload.name] || initialTableState();
      table.shouldRefresh = action.payload.shouldRefresh;
      state[action.payload.name] = table;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = tablesSlice;
// Extract and export each action creator by name
export const { fetchContentSuccess, setPage, setQuery, setRefresh } = actions;
// Export the reducer, either as a default or named export
export default reducer;
